import type { SnapshotConfig } from "../../shared/snapshot-format";
import { createCatalogue, type Catalogue } from "../engine/catalogue";
import { loadCatalogue as loadIndex } from "./catalogue";
import { DATA_ROOT, fetchJson, loadManifest } from "./manifest";

let config: Promise<SnapshotConfig> | undefined;
let catalogue: Promise<Catalogue> | undefined;

/** The config tables and rule strings shipped with the Snapshot. Fetched once per page load. */
export function loadConfig(): Promise<SnapshotConfig> {
  config ??= loadManifest().then((m) => fetchJson<SnapshotConfig>(`${DATA_ROOT}/${m.config.path}`));
  return config;
}

/** The catalogue the engine reads for ChoiceSet Pack queries and labels: index records plus config. */
export function loadEngineCatalogue(): Promise<Catalogue> {
  catalogue ??= Promise.all([loadIndex(), loadConfig()]).then(([records, cfg]) => createCatalogue(records, cfg));
  return catalogue;
}
